// extracted by mini-css-extract-plugin
module.exports = {"modal":"AddMedication_modal__23TSO"};